module.exports = __webpack_public_path__ + "img/3.2dcfa3d4.jpg";